import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'

// local components
import CompanyInfo from './CompanyInfo'
import CompanyShops from './CompanyShops'
import CompanyTerminals from './CompanyTerminals'
import LoyaltyRewards from './LoyaltyRewards'
import ResetCompanySettings from './ResetCompanySettings'
import CompanyMemberships from './CompanyMemberships'
import CompanyWeightTolerances from './CompanyWeightTolerances'
import CompanyVehicles from './CompanyVehicles'
import VehicleView from './VehicleView'
import CompanyDevKeys from './CompanyDevKeys'
import ThirdPartyAccounts from '../ThirdParty'
import RolesAndPermissions from './RolesAndPermissions'
import Regions from './Regions'
import MemberProfile from './MemberProfile'
import ReportingInfo from './ReportingInfo'
import CompanyLabels from './CompanyLabels'
import RegionsEdit from '../../../components/Regions/RegionsEdit'
import TaxesMFE from "./TaxesMFE";

export default class CompanyPage extends PureComponent {
  render() {
    const { match } = this.props

    return (
      <Fragment>
        <Route exact path={`${match.url}/`} component={CompanyInfo} />
        <Route exact path={`${match.url}/shops/`} component={CompanyShops} />
        <Route exact path={`${match.url}/loyalty`} component={LoyaltyRewards} />
        <Route exact path={`${match.url}/reset`} component={ResetCompanySettings} />
        <Route exact path={`${match.url}/terminals`} component={CompanyTerminals} />
        <Route exact path={`${match.url}/memberships`} component={CompanyMemberships} />
        <Route exact path={`${match.url}/weight`} component={CompanyWeightTolerances} />
        <Route exact path={`${match.url}/vehicles`} component={CompanyVehicles} />
        <Route exact path={`${match.url}/vehicles/:id/edit`} component={VehicleView} />
        <Route exact path={`${match.url}/vehicles/add`} component={VehicleView} />
        <Route exact path={`${match.url}/keys`} component={CompanyDevKeys} />
        <Route exact path={`${match.url}/thirdParty`} component={ThirdPartyAccounts} />
        <Route exact path={`${match.url}/roles`} component={RolesAndPermissions} />
        <Route exact path={`${match.url}/labels`} component={CompanyLabels} />
        <Route exact path={`${match.url}/regions`} component={Regions} />
        <Route exact path={`${match.url}/regions/add`} component={RegionsEdit} />
        <Route exact path={`${match.url}/regions/:id/edit`} component={RegionsEdit} />
        <Route exact path={`${match.url}/memberprofile`} component={MemberProfile} />
        <Route exact path={`${match.url}/reporting`} component={ReportingInfo} />
          <Route exact path={`${match.url}/taxes`} component={TaxesMFE} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyPage.js